import {
	OptionsMenu,
	BlockIcon,
} from '@webmotors/storybook.pf';

import { HEADER_STRINGS } from '../../../../utils/header.constants';

import type { TBlockMenuConfig } from './block-menu.types';

const BlockMenu = ({ isBlocked, onBlockMenuClick, onMenuOpen }: TBlockMenuConfig) => {
	return (
		<OptionsMenu>
			<span onPointerDown={onMenuOpen}>
				<OptionsMenu.Trigger
					aria-label={HEADER_STRINGS.OPTIONS_MENU_ARIA}
				/>
			</span>
			<OptionsMenu.Content>
				<OptionsMenu.Item
					data-testid="block-user-option"
					data-qa="block-user-option"
					onSelect={onBlockMenuClick}
					icon={isBlocked ? undefined : <BlockIcon size={16} />}
				>
					{isBlocked
						? HEADER_STRINGS.UNBLOCK_USER
						: HEADER_STRINGS.BLOCK_USER}
				</OptionsMenu.Item>
			</OptionsMenu.Content>
		</OptionsMenu>
	);
};

BlockMenu.displayName = 'BlockMenu';
export { BlockMenu };
